function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0154 1.31703L11.5413 1.79356C12.1529 2.34777 12.1529 3.24633 11.5413 3.80054L3.74088 10.8685H1V8.38496L8.80038 1.31703C9.41203 0.762814 10.4037 0.762814 11.0154 1.31703ZM7.8522 2.17617L10.5931 4.65969L7.8522 2.17617Z",
  fill: "#636363",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgEditFill = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgEditFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit_fill.899ae89c.svg";
export { ForwardRef as ReactComponent };